export default "__VITE_ASSET__fcea80e8__"